import { getAccessToken } from '@rsmus/react-auth'

/**
 * This file being used in the generation of API clients and 
 * this file should not be removed
 */

export class AuthorizedApiBase {
 
  protected transformOptions = async (
    options: RequestInit,
  ): Promise<RequestInit> => {
    options.headers = {
      ...options.headers,
      Authorization: await getAccessToken().then((at) => `Bearer ${at}`),
    }
    return Promise.resolve(options)
  }
}